import { Operateur } from '../../intervenant/models/operateur.model';
import { NatureControle } from './nature-controle.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { Animateur } from '../../commission/models/animateur.model';
import { Cahier } from '../../habilitation/models/cahier.model';
import { Produit } from '../../habilitation/models/produit.model';
import { StatutManquement } from './statut-manquement.model';

export class ManquementResultat {
    static readonly jsonMap = {
        id: 'idManquement',
        numero: 'numeroManquement',
        numeroControle: 'numeroControle',
        idOperateur: 'idOperateur',
        nature: { key: 'idNature', converter: new (DataIdConverterFactory.build(NatureControle, 'naturesControle'))() },
        dateConstat: { key: 'dateConstat', converter: new DateConverter() },
        agent: { key: 'idAgent', converter: new (DataIdConverterFactory.build(Animateur, 'agents'))() },
        cahierDesCharges: { key: 'idCahier', converter: new (DataIdConverterFactory.build(Cahier, 'cahiers'))() },
        statut: { key: 'idStatut', converter: new (DataIdConverterFactory.build(StatutManquement, 'statutsManquement'))() },
        codeProduit: 'codeProduit',
        idControle: 'idControle'
    };

    id: number;
    numero: string;
    numeroControle: string;
    idOperateur: number;
    nature: NatureControle;
    dateConstat: moment.Moment;
    agent: Animateur;
    cahierDesCharges: Cahier;
    statut: StatutManquement;
    codeProduit: string;
    idControle: number;

    operateur: Operateur;
    produit: Produit;
    cvi: string;
    raisonSociale: string;
}
